"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HightRiskChartComponent = function HightRiskChartComponent(_ref) {
  var level = _ref.level,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'big' : _ref$size;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size === 'small' ? 20 : 41,
    height: size === 'small' ? 16 : 30,
    viewBox: "0 0 41 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, level === 4 || level === 5 || level === 6 ? /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.671 14.171a20.2 20.2 0 0 1-1.14 15.41L20.501 20.5z",
    fill: "#FF3A52"
  }) : /*#__PURE__*/_react["default"].createElement("path", {
    d: "M39.6711 14.171C40.5022 16.6886 40.8294 19.3452 40.6338 21.9892C40.4382 24.6332 39.7238 27.2128 38.5313 29.5807L31.0289 25.8025C31.7253 24.4198 32.1424 22.9135 32.2566 21.3696C32.3708 19.8257 32.1798 18.2744 31.6945 16.8044L39.6711 14.171Z",
    fill: "#FF3A52",
    style: {
      mixBlendMode: 'luminosity'
    }
  }), level === 3 ? /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.9601 2.16931C33.8217 4.41304 37.5928 8.49614 39.4439 13.5204L20.5001 20.5L28.9601 2.16931Z",
    fill: "#E5B331"
  }) : /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28.96 2.17a20.2 20.2 0 0 1 10.484 11.35l-7.899 2.91a11.77 11.77 0 0 0-6.112-6.618z",
    fill: "#E5B331",
    style: {
      mixBlendMode: 'luminosity'
    }
  }), level === 2 ? /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.8527 1.8157C17.8081 -0.212494 23.3662 -0.189098 28.3044 1.88074L20.5 20.5L12.8527 1.8157Z",
    fill: "#E1E531"
  }) : /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.853 1.816a20.2 20.2 0 0 1 15.451.065l-3.253 7.762a11.77 11.77 0 0 0-9.01-.038z",
    fill: "#E1E531",
    style: {
      mixBlendMode: 'luminosity'
    }
  }), level === 1 ? /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.58441 13.4443C2.51099 10.9602 3.91777 8.68304 5.72442 6.74267C7.53107 4.8023 9.70222 3.23679 12.1139 2.1355L20.5001 20.5001L1.58441 13.4443Z",
    fill: "#8BE531"
  }) : /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.584 13.444a20.2 20.2 0 0 1 10.53-11.308l3.498 7.66a11.77 11.77 0 0 0-6.138 6.591z",
    fill: "#8BE531",
    style: {
      mixBlendMode: 'luminosity'
    }
  }), level === 0 ? /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.45413 29.5517C1.26546 27.1819 0.5552 24.6011 0.363903 21.9568C0.172606 19.3125 0.504019 16.6564 1.33922 14.1401L20.5 20.5001L2.45413 29.5517Z",
    fill: "#2BC196"
  }) : /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.454 29.552A20.2 20.2 0 0 1 1.34 14.14l7.954 2.64a11.8 11.8 0 0 0 .652 9.014z",
    fill: "#2BC196",
    style: {
      mixBlendMode: 'luminosity'
    }
  }));
};
HightRiskChartComponent.propTypes = {
  level: _propTypes["default"].oneOf([0, 1, 2, 3, 4, 5, 6]).isRequired // The risk level (1-7, from Very Low to Very High)
};
var _default = exports["default"] = HightRiskChartComponent;